import { useEffect, useState } from "react";
import "../../../assets/css/scss/section/player/_profileVideosSection.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import fontawesome from "@fortawesome/fontawesome";
import { faPlay } from "@fortawesome/fontawesome-free-solid";
import ReactPlayer from "react-player";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../../interfaces/redux";
import GetActiveDealAdvertisement from "../../../common/getActiveDealAdvertisement";
import GetAdvertisementElement from "../../../common/getAdvertisementElement";
fontawesome.library.add(faPlay);

const commonSettingsVideoPlayer = {
  controls: false,
  width: "100%",
  height: "100%",
  light: false,
  config: {
    youtube: {
      playerVars: { rel: 0 },
    },
    facebook: {
      //   appId: '12345'
    },
  },
};
export default function ProfileVideosSection(props: any) {
  const [playingVideoIndex, setPlayingVideoIndex] = useState<any>();
  const [videoList, setVideoList] = useState<any>([]);
  const [profileAdvertisement, setProfileAdvertisement] = useState({});
  const propsData = props?.data;
  const globalState = useSelector((state: IReduxStateData) => state);
  const globalActiveAdv = useSelector(
    (state: IReduxStateData) => state.activeDealAdvertisement
  );
  useEffect(() => {
    if (globalActiveAdv) {
      const advertisementForPage = GetActiveDealAdvertisement(
        globalState,
        4,
        props?.isTeam ? 2 : 3
      );
      setProfileAdvertisement(advertisementForPage || {});
    }
  }, [globalActiveAdv]);
  const onClickVideoPlayer = (videoIndex: number) => {
    if (videoIndex !== playingVideoIndex) {
      setPlayingVideoIndex(videoIndex);
    }
  };
  useEffect(() => {
    const items: any = [];
    if (propsData && propsData.length) {
      propsData?.forEach((eData) => {
        if (ReactPlayer.canPlay(eData)) {
          items.push(eData);
        }
      });
      setVideoList(items);
    }
  }, [propsData]);

  const checkVideoIsLocal = (url: string) => {
    let checkFlag = false;
    const ext = url?.split(".").pop()?.toLowerCase();
    if (
      ext &&
      (ext === "mp4" || ext === "m4a" || ext === "m4b" || ext === "mov")
    ) {
      checkFlag = true;
    }
    return checkFlag;
  };

  return (
    <div className="video-section theme-bg-white">
      {videoList.length ? (
        <div className="row justify-content-between">
          <div
            className="col-12 col-lg-8 video"
            onClick={() => {
              if (playingVideoIndex === 0) {
                onClickVideoPlayer(-1);
              }
            }}
          >
            {checkVideoIsLocal(videoList[0]) && playingVideoIndex !== 0 ? (
              <div
                className="video-play-icon-wrapper"
                onClick={() => onClickVideoPlayer(0)}
              >
                <FontAwesomeIcon className="video-play-icon" icon="play" />
              </div>
            ) : (
              <></>
            )}
            <ReactPlayer
              url={videoList[0]}
              // url={[
              //     { src: videoList[0], type: 'video/mp4' }
              // ]}
              onEnded={() => onClickVideoPlayer(-1)}
              className="video-react-player"
              {...commonSettingsVideoPlayer}
              playing={playingVideoIndex === 0}
              onStart={() => onClickVideoPlayer(0)}
              onPlay={() => {
                onClickVideoPlayer(0);
              }}
              onError={(
                error: any,
                data?: any,
                hlsInstance?: any,
                hlsGlobal?: any
              ) => console.log("error >", error)}
              // playIcon={<FontAwesomeIcon icon="play" onClick={() => onClickVideoPlayer(0)}/>}
              // playIcon={<button>Play</button>}
              // light="https://i.stack.imgur.com/zw9Iz.png"
            />
            {/* <div className="video-details mt-3">
                                <h4 className="bold text-gray">
                                    <a href="/" className="bold text-gray">
                                        JUAN SOTO IS THE BEST PLAYER
                                    </a>
                                </h4>
                                <h6 className="text-gray">Washinton Nationals</h6>
                            </div> */}
          </div>
          <div className="col-12 col-lg-4">
            <div className="row">
              {Object.keys(profileAdvertisement).length ? (
                <div className="col-md-6 col-lg-12 mb-3 video">
                  <div
                    className="advertisement-wrapper adv-image mb-3"
                    style={{ height: "150px", width: "100%" }}
                  >
                    <GetAdvertisementElement {...profileAdvertisement} />
                  </div>
                </div>
              ) : null}
              {videoList.length > 1 ? (
                <div
                  className="col-md-6 col-lg-12 video"
                  onClick={() => {
                    if (playingVideoIndex === 1) {
                      onClickVideoPlayer(-1);
                    }
                  }}
                >
                  {checkVideoIsLocal(videoList[1]) &&
                  playingVideoIndex !== 1 ? (
                    <div
                      className="video-play-icon-wrapper"
                      onClick={() => onClickVideoPlayer(1)}
                    >
                      <FontAwesomeIcon
                        className="video-play-icon-small"
                        icon="play"
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  <ReactPlayer
                    url={videoList[1]}
                    onEnded={() => onClickVideoPlayer(-1)}
                    className="video-react-player"
                    {...commonSettingsVideoPlayer}
                    playing={playingVideoIndex === 1}
                    onStart={() => onClickVideoPlayer(1)}
                    onPlay={() => onClickVideoPlayer(1)}
                  />
                </div>
              ) : null}
              {!Object.keys(profileAdvertisement).length &&
              videoList.length > 2 ? (
                <div
                  className="col-md-6 col-lg-12 mt-3 video"
                  onClick={() => {
                    if (playingVideoIndex === 2) {
                      onClickVideoPlayer(-1);
                    }
                  }}
                >
                  {checkVideoIsLocal(videoList[2]) &&
                  playingVideoIndex !== 2 ? (
                    <div
                      className="video-play-icon-wrapper"
                      onClick={() => onClickVideoPlayer(2)}
                    >
                      <FontAwesomeIcon
                        className="video-play-icon-small"
                        icon="play"
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  <ReactPlayer
                    url={videoList[2]}
                    onEnded={() => onClickVideoPlayer(-1)}
                    className="video-react-player"
                    {...commonSettingsVideoPlayer}
                    playing={playingVideoIndex === 2}
                    onStart={() => onClickVideoPlayer(2)}
                    onPlay={() => onClickVideoPlayer(2)}
                  />
                </div>
              ) : null}
            </div>
          </div>
          {videoList.length > (Object.keys(profileAdvertisement).length ? 2 : 3)
            ? videoList.map((data: any, index: number) => {
                if (
                  index > (Object.keys(profileAdvertisement).length ? 1 : 2)
                ) {
                  return (
                    <div
                      className="col-12 col-sm-6 col-md-4 video"
                      onClick={() => {
                        if (playingVideoIndex === index) {
                          onClickVideoPlayer(-1);
                        }
                      }}
                    >
                      {checkVideoIsLocal(videoList[index]) &&
                      playingVideoIndex !== index ? (
                        <div
                          className="video-play-icon-wrapper"
                          onClick={() => onClickVideoPlayer(index)}
                        >
                          <FontAwesomeIcon
                            className="video-play-icon-small"
                            icon="play"
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                      <ReactPlayer
                        url={videoList[index]}
                        onEnded={() => onClickVideoPlayer(-1)}
                        className="video-react-player"
                        {...commonSettingsVideoPlayer}
                        playing={playingVideoIndex === index}
                        onStart={() => onClickVideoPlayer(index)}
                        onPlay={() => onClickVideoPlayer(index)}
                      />
                      {/* <div className="video-img">
                                        <img
                                            src="/assets/images/video.jpg"
                                            className="img-fluid w-100"
                                            alt="video"
                                        />
                                        <FontAwesomeIcon icon={["fas", "play"]} />
                                    </div>
                                    <div className="video-details mt-3">
                                        <h4 className="bold text-gray">
                                            <a href="/" className="bold text-gray">
                                                JUAN SOTO IS THE BEST PLAYER
                                            </a>
                                        </h4>
                                        <h6 className="text-gray">Washinton Nationals</h6>
                                    </div> */}
                    </div>
                  );
                }
                return null;
              })
            : null}
        </div>
      ) : null}
    </div>
  );
}
